export const useNames = () => {
  const divideName = (name: string) => {
    const [lastName, firstNameDirty] = name.split(',')
    const firstName = firstNameDirty.trim()
    return { firstName, lastName }
  }

  function concatenateName(firstName: string, lastName: string) {
    const splittedName = firstName.trim().split(/\s+/)

    const normalizedName = formatName(splittedName)
      .concat(formatName([lastName]))
      .join(' ')

    return normalizedName
  }

  function formatName(name: string[]) {
    const formattedName = name.map((name) => {
      return name.charAt(0) + name.substring(1).toLowerCase()
    })

    return formattedName
  }
  function getFirstNameLetter(name: string) {
    const start = name.indexOf(' ') + 1
    const end = start + 1
    return name.substring(start, end)
  }

  function splitAndCapitalize(word: string): string {
    const splitWord = word.replace(/([A-Z])/g, ' $1').trim()
    return splitWord.charAt(0).toUpperCase() + splitWord.slice(1)
  }

  return { divideName, concatenateName, getFirstNameLetter, splitAndCapitalize }
}
